import injectSheet from 'react-jss'
import Autocomplete from './Autocomplete'
import styles from './Autocomplete.styles'

export default injectSheet(styles)(Autocomplete)
